import LifeInsurance from "../models/household/LifeInsurance";
import axios from "axios";

export default {
    namespaced: true,

    getters: {
        lifeInsurances() {
            return LifeInsurance.query().withAllRecursive().get();
        },
        householdLifeInsurances() {
            return (householdId) => {
               return LifeInsurance
                    .query()
                    .withAllRecursive()
                    .where('household_id', householdId)
                    .get();
            }
        },
        getLifeInsurance() {
            return (id) => LifeInsurance.find(id);
        }
    },

    actions: {
        loadLifeInsurances({commit}, {householdId}) {
            return axios
                .get(`api/household/${householdId}/life-insurances`)
                .then((response) => {
                        commit('LIFE_INSURANCES_LOADED', response.data.data.lifeInsurances);
                        return response;
                    }
                );
        },
    },

    mutations: {
        ['LIFE_INSURANCES_LOADED'](state, data) {
            if (data) {
                LifeInsurance.create({data});
            }
        },
    }
}
